import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RequiredLabelDirective } from './directives/required-label.directive';
import { FilterPipe } from './pipes/filter.pipe';
import { PlatformIconComponent } from './components/platform-icon/platform-icon.component';
import { ObjLengthPipe } from './pipes/obj-length.pipe';
import { MatInputModule } from '@angular/material/input';

import { ExpandingSearchComponent } from './components/expanding-search/expanding-search.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { QueryBuilderModule } from 'angular2-query-builder';
import { HanselMaterialModule } from '../material.module';
import { IconSpriteModule } from 'ng-svg-icon-sprite';
import { NgInitDirective } from './directives/ng-init.directive';
import { MultiRangeSliderComponent } from './components/multi-range-slider/multi-range-slider.component';
import { AutosizeDirective } from './directives/autosize.directive';
import { ConditionBuilderComponent } from './components/condition-builder/condition-builder.component';
import { TimeframeBuilderComponent } from './components/timeframe-builder/timeframe-builder.component';
import { MatNativeDateModule } from '@angular/material/core';
import { NonInitialisedAppComponent } from './components/non-initialised-app/non-initialised-app.component';
import { AverageStarRatingComponent } from './components/average-star-rating/average-star-rating.component';
import { ContentEditableComponent } from './components/content-editable/content-editable.component';
import { DisableFeatureDirective } from './directives/disable-feature.directive';
import { HideFeatureDirective } from './directives/hide-feature.directive';
import { StateSwitcherComponent } from './components/state-switcher/state-switcher.component';
import { DisableElementClickDirective } from './directives/disable-element-click.directive';
import { TimezoneSelectorComponent } from './components/timezone-selector/timezone-selector.component';
import { DayPickerComponent } from './components/day-picker/day-picker.component';
import { AmazingTimePickerModule } from '@jonijnm/amazing-time-picker';
import { NgxDaterangepickerMd } from 'ngx-daterangepicker-material';
import { DateRangePickerComponent } from './components/date-range-picker/date-range-picker.component';
import { TimeSlotPickerComponent } from './components/time-slot-picker/time-slot-picker.component';
import { TimeframeBuilderTzComponent } from './components/timeframe-builder-tz/timeframe-builder-tz.component';
import { SearchableDropdownComponent } from './components/searchable-dropdown/searchable-dropdown.component';
import { CreateAppComponent } from './components/create-app/create-app.component';
// import { Angular2PromiseButtonModule } from 'angular2-promise-buttons';
import { BranchDataComponent } from './components/branch-data/branch-data.component';
import { SharedTableComponent } from './components/shared-table/shared-table/shared-table.component';
import { ScreenCaptureAnimationDialogComponent } from './components/screen-capture-animation-dialog/screen-capture-animation-dialog.component';
import { PxLoaderComponent } from './px-loader/px-loader.component';
import { ColorPickerModule } from 'ngx-color-picker';
import { CustomDropdownComponent } from './custom-dropdown/custom-dropdown.component';
import { ListForDirective } from './directives/list-for.directive';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { MultiSelectDropdownComponent } from './multi-select-dropdown/multi-select-dropdown.component';
import { NudgeListComponent } from './nudge-list/nudge-list.component';
import { ConfirmationDialogComponent } from './confirmation-dialog/confirmation-dialog.component';
import { ChangeTemplateDialogComponent } from './change-template-dialog/change-template-dialog.component';
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    QueryBuilderModule,
    HanselMaterialModule,
    IconSpriteModule,
    MatNativeDateModule,
    MatInputModule,
    AmazingTimePickerModule,
    ReactiveFormsModule,
    NgxDaterangepickerMd.forRoot(),
    // Angular2PromiseButtonModule.forRoot({
    //   // the class used to indicate a pending promise
    //   btnLoadingClass: 'btn-loader',
    //   // only disable and show is-loading class for clicked button,
    //   // even when they share the same promise
    //   handleCurrentBtnOnly: false
    // }),
    ColorPickerModule,
    ScrollingModule
  ],
  declarations: [
    RequiredLabelDirective,
    FilterPipe,
    ObjLengthPipe,
    PlatformIconComponent,
    CreateAppComponent,
    ExpandingSearchComponent,
    NgInitDirective,
    MultiRangeSliderComponent,
    AutosizeDirective,
    ConditionBuilderComponent,
    TimeframeBuilderComponent,
    NonInitialisedAppComponent,
    AverageStarRatingComponent,
    ContentEditableComponent,
    DisableFeatureDirective,
    HideFeatureDirective,
    StateSwitcherComponent,
    DisableElementClickDirective,
    TimezoneSelectorComponent,
    DayPickerComponent,
    DateRangePickerComponent,
    TimeSlotPickerComponent,
    TimeframeBuilderTzComponent,
    SearchableDropdownComponent,
    BranchDataComponent,
    SharedTableComponent,
    ScreenCaptureAnimationDialogComponent,
    PxLoaderComponent,
    CustomDropdownComponent,
    ListForDirective,
    MultiSelectDropdownComponent,
    NudgeListComponent,
    ConfirmationDialogComponent,
    ChangeTemplateDialogComponent,
  ],
  exports: [
    RequiredLabelDirective,
    NgInitDirective,
    FilterPipe,
    ObjLengthPipe,
    PlatformIconComponent,
    ExpandingSearchComponent,
    MultiRangeSliderComponent,
    AutosizeDirective,
    DisableFeatureDirective,
    HideFeatureDirective,
    DisableElementClickDirective,
    ConditionBuilderComponent,
    TimeframeBuilderComponent,
    TimeframeBuilderTzComponent,
    NonInitialisedAppComponent,
    AverageStarRatingComponent,
    ContentEditableComponent,
    StateSwitcherComponent,
    TimezoneSelectorComponent,
    DayPickerComponent,
    DateRangePickerComponent,
    TimeSlotPickerComponent,
    SearchableDropdownComponent,
    BranchDataComponent,
    SharedTableComponent,
    PxLoaderComponent,
    CustomDropdownComponent,
    MultiSelectDropdownComponent,
    NudgeListComponent,    
    ConfirmationDialogComponent,
    ChangeTemplateDialogComponent,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class SharedModule { }
